import { Component, OnInit } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {


  firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
    {"name":"TOTAL DE ORDENES ENTREGADAS","value":"40"},
    {"name":"PROMEDIO DE ORDENES DIARIAS","value":"80"},
    {"name":"PROMEDIO DE TICKET DIARIO","value":"20"}];

  secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"60"},
    {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"10"},
    {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
    {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"0"}];

  dateNow: Date = new Date();
  dateSelect: Date = new Date();

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
	toDate: NgbDate | null;

  toggleProBanner(event) {
    event.preventDefault();
    document.querySelector('body').classList.toggle('removeProbanner');
  }

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
    this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
   }

  ngOnInit() {
  }

  date: Date = new Date();

  visitSaleChartData = [{
    label: 'CHN',
    data: [20, 40, 15, 35, 25, 50, 30, 20],
    borderWidth: 1,
    fill: false,
  },
  {
    label: 'USA',
    data: [40, 30, 20, 10, 50, 15, 35, 40],
    borderWidth: 1,
    fill: false,
  },
  {
    label: 'UK',
    data: [70, 10, 30, 40, 25, 50, 15, 30],
    borderWidth: 1,
    fill: false,
  }];

  visitSaleChartLabels = ["2013", "2014", "2014", "2015", "2016", "2017"];

  visitSaleChartOptions = {
    responsive: true,
    legend: false,
    scales: {
        yAxes: [{
            ticks: {
                display: false,
                min: 0,
                stepSize: 20,
                max: 80
            },
            gridLines: {
              drawBorder: false,
              color: 'rgba(235,237,242,1)',
              zeroLineColor: 'rgba(235,237,242,1)'
            }
        }],
        xAxes: [{
            gridLines: {
              display:false,
              drawBorder: false,
              color: 'rgba(0,0,0,1)',
              zeroLineColor: 'rgba(235,237,242,1)'
            },
            ticks: {
                padding: 20,
                fontColor: "#9c9fa6",
                autoSkip: true,
            },
            categoryPercentage: 0.4,
            barPercentage: 0.4
        }]
      }
  };

  visitSaleChartColors = [
    {
      backgroundColor: [
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
      ],
      borderColor: [
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
        'rgba(154, 85, 255, 1)',
      ]
    },
    {
      backgroundColor: [
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
      ],
      borderColor: [
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(254, 112, 150, 1)',
      ]
    },
    {
      backgroundColor: [
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
      ],
      borderColor: [
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
        'rgba(177, 148, 250, 1)',
      ]
    },
  ];

  trafficChartData = [
    {
      data: [30, 30, 40],
    }
  ];

  trafficChartLabels = ["Search Engines", "Direct Click", "Bookmarks Click"];

  trafficChartOptions = {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true
    },
    legend: false,
  };

  trafficChartColors = [
    {
      backgroundColor: [
        'rgba(177, 148, 250, 1)',
        'rgba(254, 112, 150, 1)',
        'rgba(132, 217, 210, 1)'
      ],
      borderColor: [
        'rgba(177, 148, 250, .2)',
        'rgba(254, 112, 150, .2)',
        'rgba(132, 217, 210, .2)'
      ]
    }
  ];

  //Comienzo del codigo de la fechas
  onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
			this.toDate = date;
		} else {
			this.toDate = null;
			this.fromDate = date;
		}
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

	validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
	}


  validateDate(day:string){
    switch(day){
        case "today":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"40"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"80"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"20"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"60"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"10"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"0"}];
        break;
        case "yesterday":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"40:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"540"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"200"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"10"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"178"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"41"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"5"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"0"}];
        break;
        case "7DayLast":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"1540"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"200"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"140"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"168"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"31"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"1"}];
        break;
        case "30DayLast":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"1540"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"200"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"140"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"168"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"31"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"1"}];
        break;
        case "month":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"1540"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"200"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"140"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"168"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"31"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"1"}];
        break;
        case "lastMonth":
          this.firstLine = [{"name":"TIEMPO PROMEDIO DE ENTREGA (MIN)","value":"29:00"},
            {"name":"TOTAL DE ORDENES ENTREGADAS","value":"1540"},
            {"name":"PROMEDIO DE ORDENES DIARIAS","value":"200"},
            {"name":"PROMEDIO DE TICKET DIARIO","value":"140"}];

          this.secondLine = [{"name":"TOTAL DE ORDENES CON BUENA CALIFICACIÓN","value":"168"},
            {"name":"TOTAL DE ORDENES CON MALA CALIFICACIÓN","value":"31"},
            {"name":"TOTAL DE ORDENES CANCELADAS","value":"10"},
            {"name":"TOTAL DE ORDENES SON RECHAZADAS","value":"1"}];
        break;
    }
  }

}
